<template>
  <div>
    <div class="text-center py-3">
      <p class="p--big mb-0 fw-700">
        <slot />

        <small class="mb-0" style="display: block;">{{ label }}</small>
      </p>

      <slot name="outerText" />
    </div>
  </div>
</template>

<script>
// @vuese
// Element szczegółów
// @group Details
export default {
  name: 'DetailItem',
  props: {
    // Label szczegółu
    label: {
      type: String,
      required: false
    }
  }
};
</script>

<style>
.p--big {
  font-size: 1rem;
}
</style>
